export enum AnmeldungFirstLevelPage {
  REGISTER = 'registration',
  ACQUISITION = 'acquisition',
  WORKSHOP = 'workshop',
}

export enum AnmeldungSecondLevelPage {
  // REGISTER
  OS = 'os',
  US = 'us',
  GRADUATION = 'graduation',

  // OTHER
  DECLARATION = 'declaration',

  // WORKSHOP
  REGISTRATION = 'registration',
  MANAGEMENT = 'management',
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AnmeldungRoutes {
  // Auth
  public static registerFormOs = `/${AnmeldungFirstLevelPage.REGISTER}/${AnmeldungSecondLevelPage.OS}`;
  public static registerFormUs = `/${AnmeldungFirstLevelPage.REGISTER}/${AnmeldungSecondLevelPage.US}`;
  public static registerFormGraduation = `/${AnmeldungFirstLevelPage.REGISTER}/${AnmeldungSecondLevelPage.GRADUATION}`;

  public static registerDeclaration = `/${AnmeldungFirstLevelPage.REGISTER}/${AnmeldungSecondLevelPage.DECLARATION}`;
  public static acquisition = `/${AnmeldungFirstLevelPage.ACQUISITION}`;

  // Workshop
  public static workshopRegistration = `/${AnmeldungFirstLevelPage.WORKSHOP}/${AnmeldungSecondLevelPage.REGISTRATION}`;
  public static workshopManagement = `/${AnmeldungFirstLevelPage.WORKSHOP}/${AnmeldungSecondLevelPage.MANAGEMENT}`;
}
